import React, { Component } from "react";
import classnames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";

import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import LinkIcon from "@material-ui/icons/Link";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import MapIcon from "@material-ui/icons/Map";

//import "../../assets/css/customstyles.css";

import imgUrl from "../../assets/images/imageUrl.js";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";

import ReactPlayer from 'react-player';

import Services from "../../api/api";

import Knowledge from './Knowledge';

import DialogBoxTextArea from "../DialogBox/DialogBoxTextArea";
import DialogBoxShareOnSocialMedia from "../DialogBox/DialogBoxShareOnSocialMedia";
import CommentList from '../Comment/CommentList'; 


class ChampionDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      championDetailObj: {},
      url: '',
      isLiked: false,
      totalLikes: null,
      totalComments: null,
      dialogBoxIsOpen: false,
      socialDialogBoxIsOpen: false,
      commentList: [],
    };
  }

  componentDidMount() {
    console.log("championdetail mount>>>", this.props);
    if(!this.props.location.state) {
      this.props.history.goBack();
    } else {
      this.setState({
        championDetailObj: this.props.location.state.championObj,
        url: this.props.location.state.url
      })
    }

    const { location } = { ...this.props };
    const { state } = { ...location };

    this.setState({
      totalLikes: state.championObj.totalLikes,
      isLiked: state.championObj.isLiked,
      totalComments: state.championObj.totalComments,
    });
    this.getContentWiseComments(state.championObj);
  }

  getContentWiseComments(contentobj) {
    let params = {
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
    }

    console.log("getContentWiseComments params>>", params);
    Services.getContentWiseComments(params).then((res) => {
      try{
        console.log("getContentWiseComments res>>", res);
        if (res.data.status == 200) {
          this.setState({
            commentList: res.data.data
          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  addComment() {
    this.setState({
      dialogBoxIsOpen: true,
    });
  }

  onLikeUnlike(contentobj) {
    if (this.state.isLiked) {
      this.unlikeContent(contentobj);
    } else {
      this.likeContent(contentobj);
    }
  }

  likeContent(contentobj) {
    console.log("onLike>>", contentobj);
    let params = {
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    console.log("onLike params>>", params);
    Services.likeContent(params).then((res) => {
      try{
        console.log("onlike res>>", res);
        if (res.data.status == 200) {
          this.setState({
            totalLikes: res.data.data.totalLikes,
            isLiked: true,
          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  unlikeContent(contentobj) {
    console.log("unlikeContent>>", contentobj);
    let params = {
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    console.log("unlikeContent params>>", params);
    Services.unlikeContent(params).then((res) => {
      try{
        console.log("unlikeContent res>>", res);
        if (res.data.status == 200) {
          this.setState({
            totalLikes: res.data.data.totalLikes,
            isLiked: false,
          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  addCommentToContent(contentobj, comment) {
    console.log("addCommentToContent>>", contentobj);
    let params = {
      comment: comment,
      communityId: this.props.communityuid,
      contentId: contentobj.contentId,
      contentName: contentobj.contentName,
      profileLink: "",
      userId: JSON.parse(localStorage.getItem("obj")).userId,
      userName: "",
    };
    console.log("addCommentToContent params>>", params);
    Services.addCommentToContent(params).then((res) => {
      try{
        console.log("addCommentToContent res>>", res);
        if (res.data.status == 200) {
          this.setState({
            dialogBoxIsOpen: false,
            totalComments: res.data.data.totalComments
          }, () => {
            this.getContentWiseComments(contentobj)
          });
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  toggleDialogBox(status) {
    this.setState({
      dialogBoxIsOpen: status,
    });
  }

  toggleSocialDialogBox(status) {
    this.setState({
      socialDialogBoxIsOpen: status,
    });
  }

  render() {
    const { location } = { ...this.props };
    const { state } = { ...location };

    if(!location.state) {
      this.props.history.push('/layout/getknowledgeable');
    }

    if(Object.keys(this.state.championDetailObj).length == 0) {
      return null;
    }
    console.log('render champdetail>>', this.state.championDetailObj)
    return (
      <Grid item xs={12} className="gkdivcontent zero champion-detail">
        {/* <div className="breadcrumbholder"> */}
          {/* <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" href="/">
              CHAMPIONS
            </Link>
            <Link
              color="textPrimary"
              href="/components/breadcrumbs/"
              aria-current="page"
            >
              Champion 1
            </Link>
          </Breadcrumbs> */}
        {/* </div> */}
        <div>
          <p className=" text-center championvideobig">
            <ReactPlayer
              url={this.state.url}
              width={'100%'}
              height={200}
              light={true}
              style={{marginTop: '0px'}}
            />
          </p>
        </div>
        <div className="infodetailedpostcontainer">
        <p className="posttitle">{this.state.championDetailObj.contentList[0].title}</p>
        </div>
        <div className="infolinkcontainer content-detail-action d-flex">
          <Link onClick="">
            <BookmarkBorderIcon />
          </Link>
          <Link onClick={() => this.toggleSocialDialogBox(true)}>
            <LinkIcon />
          </Link>
          <Link onClick={() => this.addComment(this.state.championDetailObj)}>
            <ChatBubbleOutlineIcon />
            <span className="likecountholder">
              {this.state.totalComments}
            </span>
          </Link>
          <Link
            className={this.state.isLiked ? "active" : ""}
            onClick={() => this.onLikeUnlike(this.state.championDetailObj)}
          >
            <ThumbUpAltIcon />
            <span className="likecountholder">
              {this.state.totalLikes}
            </span>
          </Link>
        </div>
        <div className="scrollablepost tbchamppost">
          <div className="infodetailedpostcontainer">
            <p className="postinfo">
              {this.state.championDetailObj.contentList[0].shortDesc}
            </p>
          </div>
          {this.state.commentList.length > 0 &&
            <div className="posticoncontainer">
              <p className="postinfo">Comments</p>
              <CommentList commentList={this.state.commentList}/>
            </div>
          }
        </div>
        <DialogBoxTextArea
          open={this.state.dialogBoxIsOpen}
          closeDialog={() => this.toggleDialogBox(false)}
          onSubmit={(content) => this.addCommentToContent(this.state.championDetailObj, content)}
        />
        <DialogBoxShareOnSocialMedia
          open={this.state.socialDialogBoxIsOpen}
          contentObj={this.state.championDetailObj}
          closeDialog={() => this.toggleSocialDialogBox(false)}
        />
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
  };
};

const routeChampionDetail = withRouter(ChampionDetail);
export default connect(mapStateToProps, {})(routeChampionDetail);